
export const SortBy = () => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="9" viewBox="0 0 12 9" fill="none">
      <path d="M0 8.25H3.75716V7H0V8.25ZM0 0.75V2H11.2715V0.75H0ZM0 5.125H7.51431V3.875H0V5.125Z" fill="black"/>
    </svg>
    );
  };
  